export default __webpack_public_path__ + "static/media/promotion-bottom-1.5ee1f588.jpg";